import FormItemSpecification from './FormItemSpecification'
import SkuList from './FormItemSkuList'
import { truncate, cloneDeep, clone } from 'lodash'

export const FormItemSkuList = SkuList

export const specification_mixin = {
  provide: {
    noSpPic: false, // 取消规格图片
    disabledSpName: false, // 禁用规格名输入
    disabledSpValue: false // 禁用规格值输入 
  },
  components: {
    FormItemSkuList,
    FormItemSpecification
  },
  data() {
    return {
      specifications: [],
      skuImgOnlyPreview: true, // sku的预览图是否只能预览不能编辑
      skuList: [],
      displayValueMaps: {}, // 用于记录值对应的展示名
    }
  },
  computed: {
    computedValueForm() {
      let form = {}
      this.skuTableCols.forEach(item => {
        if (item.input) {
          form[item.prop] = ''
        }
      })
      return form
    },
    specificationNames() {
      return this.specifications.map(item => {
        let nameObj = {
          name: item.name
        }
        if (item.nameKey) {
          nameObj.nameKey = item.nameKey
        }
        return nameObj
      })
    }
  },
  watch: {
    specifications: {
      // 监听规格信息生成规格详情列表
      handler(v) {
        /**
         * 拓展字段值的改变是不需要影响到详情列表的生成的
         * 所以直接return掉，否则会有卡顿感
         */
        if (window.__tmExtendsChange__) {
          window.__tmExtendsChange__ = false
          return 
        }
        const self_form_key = this.mixinsFormKey ? this.mixinsFormKey : 'self_form'
        const skuListKey = 'skuList';
        const self_skuSpecifications_key = this.skuSpecificationsKey ? this.skuSpecificationsKey : 'skuSpecifications'
       
        if (v.length < 1 || !this[self_form_key]) {
          this.skuList = []
          return
        }
        // 有没创建规格值的的规格就不生成skulist
        let hasNoValues = false
        if (!v.filter(item => item.name).length) {
          hasNoValues = true
        }
        v.filter(item => item.name).forEach(item => {
          if (hasNoValues) return
          if (item.values.length) return
          if (item.values.filter(i => i.checked).length) return
          hasNoValues = true
        })

        if (hasNoValues) {
          this.skuList = []
        } else {
          let _skuList = []
          const that = this
          const allIsEdited = v.some(s => s.isEdited)
          const originSkuList = cloneDeep(that[self_form_key][skuListKey])
          function forEach(arr, index = 0, c_arr = []) {
            // 取到最后一层开始作业务逻辑
            if (arr.length === index) {
              // 若有值为空或未勾选不做任何处理
              if (c_arr.some(item => (!item.value || !item.checked))) {
                return;
              }
              const valueKeys = c_arr.filter(item => !!item.valueKey).map(item => item.valueKey)
              const _skuid = valueKeys.join('-') // 生成skuid
              const _skuSpecifications = c_arr.map((item,index) => { //生成sku明细
                
                const _sp = {
                  checked: that.getChecked(v[index].nameKey, item.valueKey, v),
                  name: v[index].name,
                  value: item.value,
                  nameKey: v[index].nameKey,
                  valueKey: item.valueKey
                }
                
                // 处理用于展示的规格值
                if (['SINGLECHECK', 'MULTICHECK'].includes(v[index].ui.type)) {
                  // 此规格是下拉框类型的需要寻找options里对应的displayName
                  _sp._displayValue = v[index].ui.options?.find(op => op.value === item.value)?.displayName || item.value  || '未知'
                  that.displayValueMaps[item.value] = _sp._displayValue
                } else {
                  // 默认直接取value
                  _sp._displayValue = item.value
                  that.displayValueMaps[item.value] = item.value
                }


                // 非sku预览图只可预览的表单且当前商品图片规格没改过，需要在原self_form里面skuList字段取图片数据
                // 而不是通过_skuSpecifications中取
                if (!that.skuImgOnlyPreview && !window.__spcificationImg_changed) {
                  const selfSku = that.findSkuListItem(originSkuList, valueKeys).item
                  if (selfSku && !window.__spcificationCheckbox_changed) {
                    _sp.imageUrl = selfSku.imageUrl || selfSku[self_skuSpecifications_key][0].imageUrl || ''
                  } else {
                    // 备注和勾选修改
                    const thisSku = that.findSkuListItem(that.skuList, valueKeys).item
                    if (thisSku && thisSku[self_skuSpecifications_key][0].imageUrl) {
                      // 如果当前sku table里面有图片，则不从spec里面取
                        _sp.imageUrl = thisSku.imageUrl || thisSku[self_skuSpecifications_key][0].imageUrl || ''
                    } else {
                        _sp.imageUrl = item.imageUrl || ''
                    }
                  }
                } else {
                  if (window.__spcificationImg_changed) {
                    // 规格图改变且是当前sku有包含改变的规格字段就取规格图
                    if (_skuid.indexOf(window.__spcificationImg_changed) > -1) {
                      _sp.imageUrl = item.imageUrl || ''
                    } else {
                      // 否则取当前skuList中的图片
                      const thisSku = that.findSkuListItem(that.skuList, valueKeys).item || {}
                      if (thisSku) {
                        _sp.imageUrl = thisSku[self_skuSpecifications_key][0].imageUrl
                      } else {
                        _sp.imageUrl = item.imageUrl || ''
                      }
                    }
                  } else {
                    _sp.imageUrl = item.imageUrl || ''
                  } 
                }   
                return _sp
              })
           
              // 修改后的sku生成逻辑
              let skuItem;
              const isEdited = c_arr.some(s => s.isEdited)
              const isGray = !(isEdited || allIsEdited) 

              // 1. 查找当前skuList
              skuItem = that.findSkuListItem(that.skuList, valueKeys).item
              if (skuItem) {
                skuItem.isGray = skuItem.isGray ? isGray : skuItem.isGray
                skuItem[self_skuSpecifications_key] = _skuSpecifications;
                _skuList.push(skuItem);
                return;
              }

              // 2. 查找self_form中的skuList
              const selfSkuObj = that.findSkuListItem(originSkuList, valueKeys)
              skuItem = selfSkuObj.item
              if (skuItem) {
                that.processSkuFieldDescriptors(skuItem);
                skuItem[self_skuSpecifications_key] = _skuSpecifications;
                _skuList.push(skuItem);
                originSkuList.splice(selfSkuObj.index, 1)
                return;
              }

              // 3. 创建新的skuItem
              skuItem = that.createBaseSkuItem(_skuid);
              skuItem[self_skuSpecifications_key] = _skuSpecifications;
              skuItem.isGray = isGray
              _skuList.push(skuItem);
              return;
            }

            // 取出一层
            let currItem = arr[index]
            // 此层值循环
            currItem.values.forEach(c => {
              // 每个值再递归取
              forEach(arr, index + 1, c_arr.concat(c))
            })
          }
          forEach(v.filter(item => item.name))
          this.skuList = _skuList
          window.__spcificationImg_changed = ''
          window.__spcificationCheckbox_changed = false;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 新增方法：查找sku
    findSkuListItem(list, valueKeys) {
      const self_skuSpecifications_key = this.skuSpecificationsKey ? this.skuSpecificationsKey : 'skuSpecifications'
      const newValueKeys = valueKeys.reduce((newKeys, key) => {
        newKeys.push(...key.split('______')) // 淘宝、天猫‘选择展示模式’切换时的特殊处理
        return newKeys
      }, [])
      const index = list.findIndex(sku => {
        const skuValueKeys = (sku[self_skuSpecifications_key] || []).filter(item => !!item.valueKey).map(item => item.valueKey) 
        let isMatch = valueKeys.every(key => skuValueKeys.includes(key))
        if(!isMatch) {
          isMatch = newValueKeys.every(key => skuValueKeys.includes(key))
        }
        return isMatch
      })
      return {
          index, 
          item: index > -1 ? cloneDeep(list[index]) : null
      }
    },
    // 新增方法：创建基础skuItem
    createBaseSkuItem(skuId) {
      return {
        _skuid: skuId,
        ...JSON.parse(JSON.stringify(this.computedValueForm))
      };
    },

    // 新增方法：处理sku字段描述符
    processSkuFieldDescriptors(skuItem) {
      const needSkuFieldDescriptorList = ['outSkuPlatform', 'cspuId'];
      (skuItem.skuFieldDescriptorList || [])
        .filter(item => /^sku_/.test(item.name) || needSkuFieldDescriptorList.includes(item.name))
        .forEach(attr => {
          skuItem[attr.name] = attr.defaultValue;
        });
    },
    // 根据nameKey、valueKey获取checked值
    getChecked(nameKey, valueKey, specifications) {
      try {
        return specifications.find(item => item.nameKey === nameKey).values
        .find(item => item.valueKey === valueKey).checked
      } catch (error) {
        return false
      }
    },
    // 根据nameKey、valueKey获取指定的规格值对象
    _mix_getSpItem(nameKey, valueKey, specifications) {
      try {
        return specifications.find(item => item.nameKey === nameKey).values
        .find(item => item.valueKey === valueKey)
      } catch (error) {
        return null
      }
    },
    // 校验规格信息
    validateSpecifications(specifications) {
      if(this.form.pureType) return true;

      if (!this.skuList.length) {
        this.$message.error('请补充商品规格及规格明细')
        return false
      }

      const errorReg = /[|,\^]+/ // 规格名与值不允许输入 ^|, 三种符号

      let errmsg = null;
      specifications = specifications || this.specifications;
      for (let index = 0; index < specifications.length; index++) {
        const specification = specifications[index];
        if (!specification.name) {
          this.$message.error('请补充规格名')
          return false
        }
        if (this.needValiSymbol && errorReg.test(specification.name)) {
          this.$message.error(`规格名:${specification.name} 请勿包含^|,符号`)
          return false
        }

        

        let valiArr = [] // 有效的规格值
        for (let vindex = 0; vindex < specification.values.length; vindex++) {
          const value = specification.values[vindex]
          if (!value.checked) {
            // 未勾选不校验
            continue
          }
          if (!value.value || value.valueErrorMsg) {
            // 校验规格值不能为空
            errmsg = `${specification.name}规格下的规格值未完善`
            this.$message.error(errmsg)
            return false
          }
          if (this.needValiSymbol && errorReg.test(value.value)) {
            this.$message.error(`规格值:${value.value} 请勿包含^|,符号`)
            return false
          }
          if (this.specification_needImg && index === 0 && !value.imageUrl) {
            // 该表单是否需要图片 && 第一个规格需要校验图片 && 图片不能为空
            errmsg = `${specification.name}规格下的图片未完善`
            this.$message.error(errmsg)
            return false
          }
          if (valiArr.includes(value.value)) {
            errmsg = `${value.value}规格值重复`
            this.$message.error(errmsg)
            return false
          }
          valiArr.push(value.value)
        }
        // if (valiArr.length > 50) {
        //   errmsg = `${specification.name}的规格值数量超过50`
        //   this.$message.error(errmsg)
        //   return false
        // }
        continue;
      }
      return true
    },
    // 校验skuList
    validateSkuList() {
      // 校验空值
      const validateVoid = (value, prop) => {
        if (value === "" || value === undefined) {
          return `${prop.label}请勿输入空值`
        }
        return false
      }

      // 需要校验的props
      const props = this.skuTableCols.filter(item => item.input).map(item => {
        let validator = item.input.validator || (!item.attrs.noRequired ? validateVoid : null)
        let newitem = {
          ...item,
          prop: item.prop,
          label: item.attrs.label,
          validator,
        }
        if (item.input.custom_validator) {
          delete newitem.validator
          newitem.custom_validator = item.input.custom_validator
        }
        return newitem
      })
      for(let index = 0; index < this.skuList.length; index++) {
        const sku = this.skuList[index]
        if(!sku.skuOuterId) continue;
        for (let pidex = 0; pidex < props.length; pidex++) {
          const prop = props[pidex];
          if (prop.custom_validator) {
            const custom_pass = prop.custom_validator(sku, prop.prop)
            if (!custom_pass) {
              this.$message.error('请完善商品明细!')
              return false
            } 
          } else if (prop.validator) {
            const errmsg = prop.validator(sku[prop.prop], prop)
            if (errmsg) {
              this.$message.error(errmsg)
              return false
            }
          }
        }
      }
      return true
    },
    validateStdList() {
      return this.$refs.StdSizeExtendsRef ? this.$refs.StdSizeExtendsRef.validateStdList() : true;
    },
    // 清空数据
    // 由于dialog关闭未销毁实例，会有数据缓存问题，需要在弹窗关闭时调用一下
    clear_specification() {
      this.specifications = []
    },
    // 获取规格与规格明细数据
    getSpecificationData(specifications) {
      specifications = specifications || JSON.parse(JSON.stringify(this.specifications))
      const self_form_key = this.mixinsFormKey ? this.mixinsFormKey : 'self_form'
      const self_skuSpecifications_key = this.skuSpecificationsKey ? this.skuSpecificationsKey : 'skuSpecifications'
      const origin_skuList = this[self_form_key].skuList

      const checkedValueKeys = []
      const stdSizeExtendsData = this.$refs?.StdSizeExtendsRef?.method_getStdSizeData() || {}

      // 平台资料需要对规格的checkbox做一些处理
      // 顺带处理下天猫的拓展字段
      specifications.forEach((item, index) => {
        if(item.nameKey.includes('std_size_prop_')) {
          item.extendValues = {
            ...item.extendValues,
            tm_std_size_extends: stdSizeExtendsData.tm_std_size_extends
          }
        }
        delete item.isEdited

        item.values.forEach((v, vi) => {
          delete v.isEdited
          v.name = item.name
          v.nameKey = item.nameKey
          for (let key in v.extendValues) { // 把extendValues中的原尺码表数据删除
            if (key.startsWith('size_mapping_')) {
              delete v.extendValues[key];
            }
          }
          // 处理extendValues字段中的规格值信息
          if (v.extendValues) {
            v.extendValues[item.nameKey] = v.trueValue || v.value;
          }
          v.extendValues = {
            ...v.extendValues,
            prop_image: v.imageUrl,
            ...stdSizeExtendsData[v.value]
          }

          // 如果未勾选，需要获取之前的数据进行填充
          if (v.checked) {
            checkedValueKeys.push(v.valueKey)
          }
        })
      })

      let skuList = ''
      skuList = origin_skuList.map(item => {
        if(item.isGray) return false
        const _curr_sku = this.skuList.find(s => s._skuid === item._skuid)
        if (_curr_sku) {
          // 当前sku在sku_table上
          // 将当前sku覆盖源sku
          _curr_sku[self_skuSpecifications_key].forEach(sp => sp.checked = true)
          let sku = {
            ...item,
            ..._curr_sku
          }
          return sku;
        } else {
          // 源sku不动 只更改checked值
          let sku = {
            ...item
          }
          sku[self_skuSpecifications_key].forEach(sp => {
            if (checkedValueKeys.includes(sp.valueKey)) {
              sp.checked = true
            } else {
              sp.checked = false
            }
          })
          return sku
        }
      })

      return [specifications, skuList.filter(Boolean)]
    }
  }
}

export default FormItemSpecification
